import { render, staticRenderFns } from "./page.vue?vue&type=template&id=1dc2bb6c&scoped=true&"
var script = {}
import style0 from "./page.vue?vue&type=style&index=0&id=1dc2bb6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc2bb6c",
  null
  
)

component.options.__file = "page.vue"
export default component.exports